import React, { Component , useEffect, useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import Cardrecado from '../componentes/cardrecado';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''



export const  Recados = withRouter(({history}) => {
  const [listarecados, setalistarecados]=React.useState([]);
  const [strecado, setastrecado]=React.useState("2");
  var listarecado=[]
  const user=authConfig.auth().currentUser;;
  ///**********************************************
  /*
  React.useEffect(() => {
    pegauser()
    async function pegauser(){
      //user = authConfig.auth().currentUser;
      //pegarecado(user)
      setastrecado("2")
    }

 
  
},[0])
  //************************************* */
  React.useEffect(() => {
  //async function pegarecado(ut3) {   
    console.log("pegando recados",strecado)   
    console.log("pegando recados") 
    setalistarecados ([]);
    if(strecado=="1"){
    var db = firebase.firestore();
                    var query = db.collection("usuarios").doc(user.uid).collection("recados").orderBy("datarecado", "desc").get()
                    .then(function(querySnapshot) {
                      listarecado=[];
                     querySnapshot.forEach(function(doc) {
                      
                      listarecado.push({uid:user.uid, idrecado:doc.id, recado:doc.data().recado, datarecado:doc.data().datarecado, statusrecado:doc.data().statusrecado})
                      
            
                     });
                     console.log(listarecado);
                     setalistarecados (listarecado);
                    
                   })
                  .catch(error => {
                      console.log('Não encontramos recados cadastrados', error);
                  });
                  
                }else{
                  if (strecado=="2") {
                    var db = firebase.firestore();
                    var query = db.collection("usuarios").doc(user.uid).collection("recados").where("statusrecado","==","novo").orderBy("datarecado", "desc").get()
                    .then(function(querySnapshot) {
                      listarecado=[];
                     querySnapshot.forEach(function(doc) {
                      
                      listarecado.push({uid:user.uid, idrecado:doc.id, recado:doc.data().recado, datarecado:doc.data().datarecado, statusrecado:doc.data().statusrecado})
                      
            
                     });
                     console.log(listarecado);
                     setalistarecados (listarecado);
                    
                   })
                  .catch(error => {
                      console.log('Não encontramos recados cadastrados', error);
                  });
                  } else {
                    if(strecado=="3"){
                      var db = firebase.firestore();
                      var query = db.collection("usuarios").doc(user.uid).collection("recados").where("statusrecado","==","lido").orderBy("datarecado", "desc").get()
                      .then(function(querySnapshot) {
                        listarecado=[];
                       querySnapshot.forEach(function(doc) {
                        
                        listarecado.push({user:user.uid, idrecado:doc.id, recado:doc.data().recado, datarecado:doc.data().datarecado, statusrecado:doc.data().statusrecado})
                        
              
                       });
                       console.log(listarecado);
                       setalistarecados (listarecado);
                      
                     })
                    .catch(error => {
                        console.log('Não encontramos recados cadastrados', error);
                    });
                    }
                  }
                }           
     
    //}
  },[strecado])

  const handleChangeman=(event)=>{
    var v = event.target.value;
    setastrecado(v);
  }
 
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      <br></br>
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Recados
          </Typography>
          

          <Container align='center'>
        <Grid container align="center">
        <Grid item xs>
          <FormControl component="fieldset">
      
      <RadioGroup row  aria-label="gender" name="gender1" value={strecado} onChange={handleChangeman}>
        <FormControlLabel value="2" control={<Radio />} label="Não Lidos" />
         <FormControlLabel value="3" control={<Radio />} label="Lidos" />
         <FormControlLabel value="1" control={<Radio />} label="Todos" />
        </RadioGroup>
    </FormControl>
    </Grid>
    </Grid>
    </Container>
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">
           <Container maxWidth="xs">
            
              {console.log(listarecados.length)}
              {console.log(listarecados.length)}
                      
               {listarecados.map(item =>(
           <Cardrecado  props={item} />
           //console.log(item)
                ))}
               
            

             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Recados;
